module.exports = __webpack_public_path__ + "static/media/talk-to-a-coach@3x.1b8a7a2c.png";